.layout {
  width: 100vw;
  min-height: calc(100svh - 3.75rem);
  margin-top: -2rem;
  margin-bottom: -3rem;
  margin-left: calc(50% - 50vw);
}

@media (max-width: 800px) {
  .layout {
    width: calc(100% + 2rem);
    margin-left: -1rem;
  }
}